module.exports = __webpack_public_path__ + "media/images/mailers/mailer-header-66f1c57b10850f06cf34d85d133ff465.png";